import { useIsGuestUser, useIsPickup } from '@/features/account/services/User/hooks'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicChooseStoreModal } from '@/features/account/components/Modal/ChooseStoreModal/DynamicChooseStoreModal'
import { DynamicGuestAddressModal } from '@/features/account/components/Modal/GuestAddressModal/DynamicGuestAddressModal'
import { SegmentedControl } from '@shipt/design-system-segmented-control'

export const DeliveryPickupSwitch = () => {
  const isPickup = useIsPickup()
  const { openDialog } = useHandleDialog()
  const isGuestUser = useIsGuestUser()

  const handleClick = () => {
    if (isGuestUser) {
      return openDialog(DynamicGuestAddressModal)
    }
    openDialog(DynamicChooseStoreModal)
  }

  return (
    <SegmentedControl value={isPickup ? 'pickup' : 'delivery'} isContained size="sm">
      <SegmentedControl.RadioGroup onClick={handleClick}>
        <SegmentedControl.Radio label="Delivery" value="delivery" />
        <SegmentedControl.Radio label="Pickup" value="pickup" />
      </SegmentedControl.RadioGroup>
    </SegmentedControl>
  )
}
